module.exports = __webpack_public_path__ + "static/media/2020.e75b1302.png";